import BarracksForm from "./BarracksForm";

export default BarracksForm;
